import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconClockPast = ({ className = '', color = '#444', height = 14, title, width = 16 }: Icon) => (
    <AccessibleSVG
        className={`icon-clock-past ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 14"
        width={width}
    >
        <g fill="none" fillRule="evenodd" transform="translate(0 1)">
            <rect className="fill-color" fill={color} height="5" rx=".5" width="1" x="9.66" y="3" />
            <rect className="fill-color" fill={color} height="1" rx=".5" width="3" x="9.66" y="7" />
            <path
                className="stroke-color"
                d="M5.66 10.62C6.697 11.48 8.032 12 9.487 12c3.314 0 6-2.686 6-6s-2.686-6-6-6c-3.313 0-6 2.686-6 6"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path className="fill-color" d="M6.317 5l-2.83 2.828L.66 5" fill={color} />
        </g>
    </AccessibleSVG>
);

export default IconClockPast;
